import { cn } from '../../lib/utils';

export const StatCard = ({ 
    title, 
    value, 
    subtitle,
    icon: Icon,
    iconColor = 'bg-primary/10 text-primary',
    trend,
    className = '',
    children
}) => {
    return (
        <div className={cn('stat-card', className)} data-testid="stat-card">
            <div className="flex items-start justify-between">
                <div className="flex-1">
                    <p className="text-sm font-medium text-slate-500">{title}</p>
                    <p className="stat-number text-3xl mt-2">{value}</p>
                    {subtitle && (
                        <p className="text-sm text-slate-400 mt-1">{subtitle}</p>
                    )}
                    {trend && (
                        <div className={`flex items-center gap-1 mt-2 text-sm ${trend > 0 ? 'text-emerald-600' : 'text-red-500'}`}>
                            <span>{trend > 0 ? '+' : ''}{trend}%</span>
                            <span className="text-slate-400">vs last week</span>
                        </div>
                    )}
                </div>
                {Icon && (
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${iconColor}`}>
                        <Icon className="w-6 h-6" strokeWidth={1.5} />
                    </div>
                )}
            </div>
            {children}
        </div>
    );
};
